export const CLUBREPORTLIST_SEARCH = 'CLUBREPORTLIST_SEARCH';
export const CLUBREPORTLIST_PAGE = 'CLUBREPORTLIST_PAGE';
export const CLUBREPORTLIST_STARTDATE = 'CLUBREPORTLIST_STARTDATE';
export const CLUBREPORTLIST_ENDDATE = 'CLUBREPORTLIST_ENDDATE';
export const CLUBREPORTLIST_CLUBID = 'CLUBREPORTLIST_CLUBID';
